import React, { useEffect, useRef, useState } from "react";
import {Card, CardBody, CardTitle, Col, Input, Row, Spinner} from "reactstrap";
import { connect, useSelector } from "react-redux";
import { getStateByPath } from "../../../../redux/selectors";
import {
    ADD_STATE,
    REMOVE_STATE, setApp, setForm,
    setItem,
} from "../../../../redux/actions/generics/IndexedActions";
import { GenericButton } from "../../../../components/buttons/customButtons";
import { genericIndexedActions } from "../../../../redux/actions/generics/GenericIndexedActions";
import {TT_CLOSE, TT_EDIT} from "../../../../components/i18n/toolTips";
import {sectionService} from "../../../../jwt/_services/landings/sectionService";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {SectionsSectionForm} from "./_form";
import Widgets from "../../../landings/section/widgets/Wisgets";

const SectionsSection = (props) => {
    const path = props.path + "/section";

    const parentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject, app, udn } = parentState?.data || {};
    const { listDomainObjects } = componentState?.data || [];
    const { loading, editMode } = componentState?.data || false;

    const [selectedIndex, setSelectedIndex] = useState(-1);
    
    const [mappedItems, setMappedItems] = useState([]);
    const [showFormModal, setShowFormModal] = useState(true);
    const formModalRef = useRef(null);




    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);

    useEffect(() => {
        if (!app || !domainObject?.id)
            return;

        props.setApp(path, app)

        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                event: { id: domainObject?.id },
            },
        };

        genericIndexedActions.search(path, sectionService, 0, 1000, dataRequest);
    }, [domainObject, app]);

    useEffect(()=>{
        setMappedItems(listDomainObjects?.sort((a, b) => a?.showOrder - b?.showOrder))
        if (selectedIndex === -1 && listDomainObjects?.length > 0) {
            setSelectedIndex(0);
            props.setItem(path, listDomainObjects[0]);
        }
    }, [listDomainObjects])

    const showForm = (item) => {
        setShowFormModal(true);
        formModalRef.current.showModal(item, listDomainObjects.length, domainObject);
    };

    const onCreateItem = (data) => {
        showForm(null);
    };

    const onEditItem = (_item) => {
        const item = listDomainObjects.find((i) => i.id === _item.id);

        setItem(path, item);
        showForm(item);
    };

    const returnToList = () => {
        props.setItem(props.path, null);
        props.setForm(false, false, false);
        props.onClose();
    }
    
    const notImplemented = () => {
        console.log('not implemented');
    }

    const selectIndex = (_index) => {
        // console.log(listDomainObjects[_index]?.langs[0]?.longDescription)

        setSelectedIndex(_index)

        // find item lang with showOrder = 1
        // let itemLang = listDomainObjects[_index]?.langs.find(l => l?.lang?.showOrder === 1);
        // if (itemLang?.longDescription) {
        //     setSelectedItemDescription(itemLang?.longDescription);
        // } else {
        //     setSelectedItemDescription('');
        // }

        props.setItem(path, listDomainObjects[_index]);
    }

    const renderContent = (item, index) => {
        const lbl = listDomainObjects[index]?.title || '---'

        let checkedClass = '';

        if (index === selectedIndex) {
            checkedClass = 'xwitch-checked';
        } else if (listDomainObjects[index]?.status === true) {
            checkedClass = 'xwitch-unchecked';
        } else {
            checkedClass = 'xwitch-null';
        }

        return (
            <div className={'sub-category-item ' + checkedClass} onClick={_ => { selectIndex(index) }}>
                <label>{lbl?.toUpperCase().replace('_', ' ')}</label>
                { index === selectedIndex && <GenericButton
                    style={'table'}
                    toolTip={TT_EDIT}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={_ => onEditItem(item, index)}/>}
            </div>
        )
    }



    const onReorder = (reorderProps) => {
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps?.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem?.id) {
                // Buscar el ítem en mappedItems
                let domainObject = mappedItems.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject?.showOrder !== reorderedItem?.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, sectionService, dataRequest)
    }

    return (
        <>
            <Card className={"card-modal-medium"}>
                {/*{loading && showLoader()}*/}
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-columns mr-2"/>
                    {"Secciones"}
                    <div className="top-right">
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={""}>
                    <div className={"vertical-container media-section-body"}>
                        {loading ? (
                            <Spinner animation="border"/>
                        ) : (
                            <>
                                {
                                    listDomainObjects?.length === 0 ?
                                        <div className={'sauser-add'}>
                                            <h4>{'No hay secciones'}</h4>
                                            <GenericButton
                                                style={'table'}
                                                label={'Agregar sección'}
                                                toolTip={'Genera un nuevo apartado para actividades'}
                                                icon={'fa-plus'}
                                                permission={'add'}
                                                onClick={_ => onCreateItem()}/>
                                        </div> : <div>
                                            <Row>
                                                <GenericButton
                                                    style={'table'}
                                                    label={'Agregar sección'}
                                                    toolTip={'Genera un nuevo apartado para actividades'}
                                                    icon={'fa-plus'}
                                                    permission={'add'}
                                                    onClick={_ => onCreateItem()}/>
                                            </Row>
                                            <Row className={'sauser-container-header'}>
                                                <DragDropList
                                                    items={mappedItems}
                                                    renderContent={renderContent}
                                                    onReorder={onReorder}
                                                    orientationHV={'horizontal-container'} // CSS class para orientar los elementos horizontalmente
                                                />
                                            </Row>
                                            {/*<Row>*/}
                                            {/*    <div className={'sub-category-section'}>*/}
                                            {/*        <ActivitySection path={path}/>*/}
                                            {/*    </div>*/}
                                            {/*</Row>*/}
                                        </div>
                                }
                            </>
                        )}
                    </div>
                    <Row>
                        <div className={'sub-category-section'}>
                            {/*<WidgetSection path={path}/>*/}
                            {
                                selectedIndex !== -1 &&
                                <Col>
                                    <Widgets path={path} />
                                </Col>
                            }
                        </div>
                    </Row>
                </CardBody>
            </Card>
            { showFormModal && (
                <SectionsSectionForm
                    path={path}
                    parent={domainObject}
                    udn={udn}
                    app={app}
                    ref={formModalRef}
                />
            )}
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
    setItem,
    setForm,
    setApp
};

export default connect(mapStateToProps, mapActionsToProps)(SectionsSection);
